import { ContentBox } from "@msuite/ui/content-box";
import { LoadCarriersTable } from "@/components/stock/load-carriers-table";
import { LoadCarriersMenu } from "./load-carriers-menu";

export function LoadCarriers() {
	/** Render */
	return (
		<ContentBox>
			<LoadCarriersTable
				menu={<LoadCarriersMenu />}
				variant="table"
			/>
		</ContentBox>
	);
}
